<template>
  <footer>
    <div id="sitemap">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-3 col-md-3">
            <h4>Arrecadação</h4>
            <ul>
              <li><router-link to="/about" href="">Como funciona</router-link></li>
              <li><router-link to="/create-project" href="">Cadastre sua ONG</router-link></li>
              <li><router-link to="/about" href="">Quem somos</router-link></li>
              <!-- <li><a href="http://blog.click2giv.com" target="_blank">Nosso blog</a></li> -->
            </ul>
          </div>
          <div class="col-sm-6 col-md-6">
            <h4>Categorias</h4>
            <div class="row">
              <div class="col-sm-4">
                <ul>
                  <li><router-link to="/projects" href="">Todos</router-link></li>
                  <li v-for="c in col1" v-bind:key="c.CategoryId">
                    <a :href="'/projects/' + c.url">{{c.name}}</a>
                  </li>
                </ul>
              </div>
              <div class="col-sm-4">
                <ul>
                  <li v-for="c in col2" v-bind:key="c.CategoryId">
                    <a :href="'/projects/' + c.url">{{c.name}}</a>
                  </li>
                </ul>
              </div>
              <div class="col-sm-4">
                <ul>
                  <li v-for="c in col3" v-bind:key="c.CategoryId">
                    <a :href="'/projects/' + c.url">{{c.name}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <h4>Contato</h4>
            <ul>
              <li><router-link to="/terms-and-conditions" href="">Termos de Uso</router-link></li>
              <li><router-link to="/privacy-policy" href="">Política de Privacidade</router-link></li>
              <li><a href="https://click2giv.helpscoutdocs.com/article/41-politica-de-cancelamento" target="_blank">Política de Cancelamento</a></li>
              <li><a href="https://click2giv.helpscoutdocs.com" target="_blank">Perguntas Frequentes</a></li>
              <li><a href="https://click2giv.helpscoutdocs.com" target="_blank">Entre em Contato</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div id="copyright">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <span class="row">Click2giv Serviços Online Ltda. - CNPJ 24.636.206/0001-70</span>
            <span class="row">Alameda Santos, 905 - 8 andar, sala 7 - Cerqueira César - São Paulo/SP</span>
            <span class="row">✉ meajuda.suporte@click2giv.com - <b>☎ (11) 98741-1000</b></span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { API } from '../../services/api'

export default {
  name: 'Footer',
  data () {
    return {
      categories: false,
      col1: false,
      col2: false,
      col3: false
    }
  },
  created(){
    this.loadCategories()
  },
  methods: {
    loadCategories(){
      this.$http.get(API.Projects.categories).then((result) => {
        this.categories = result.body;
        var cat1 = this.categories;
        var cat2 = this.categories;
        var cat3 = this.categories;
        this.col1 = cat1.slice(0, 3);
        this.col2 = cat2.slice(3, 7);
        this.col3 = cat3.slice(7, 11);
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
footer{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 430px;

  @media screen and (max-width: 767px ){
    display: none;
    height: 10px;
  }

  #sitemap{
    background-color: #eee;
    padding: 40px;

    h4{
      font-family: RalewayBold;
      color: #00AE39;
      font-size: 20px;
      padding-bottom: 20px;
    }

    ul{
      list-style: none;
      padding: 0;

      li{
        padding-top: 5px;
        padding-bottom: 5px;

        a{
          font-size: 15px;
          color: #000;
          font-family: RalewayRegular;
          text-decoration: none;
        }
      }
    }
  }

  #copyright{
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 40px;
    padding-right: 40px;
    background-color: #333;


    span{
      display: block;
      text-align: center;
      font-size: 16px;
      font-family: RalewayRegular;
      color: #fff;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/includes/Footer.vue